import { useCallback, useEffect, useRef } from 'react';

const REGION_ID = 'style-transfer-live-region';
const REGION_CLASS = 'sr-only';

function ensureRegion() {
  let region = document.getElementById(REGION_ID);
  if (!region) {
    region = document.createElement('div');
    region.id = REGION_ID;
    region.className = REGION_CLASS;
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
  }
  return region;
}

export function useLiveRegion() {
  const regionRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    regionRef.current = ensureRegion();
  }, []);

  return useCallback((message: string) => {
    if (!regionRef.current) return;
    regionRef.current.textContent = '';
    window.setTimeout(() => {
      if (regionRef.current) {
        regionRef.current.textContent = message;
      }
    }, 80);
  }, []);
}
